import httpClient from './httpClient';
import { LoginResponse, LogoutResponse, RefreshTokenResponse } from '../types/auth';

const AUTH_ENDPOINTS = {
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  REFRESH_TOKEN: '/auth/refresh-token'
};

/**
 * Authentication Service Layer
 * Encapsulates all authentication API calls
 * Uses httpClient for request/response handling
 */
export const authService = {
  /**
   * User login endpoint
   * @param email - User email
   * @param password - User password
   * @returns Login response with tokens and user data
   */
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const response = await httpClient.post<LoginResponse>(AUTH_ENDPOINTS.LOGIN, {
      email,
      password
    });
    return response;
  },

  /**
   * User logout endpoint
   * Requires valid authentication token (auto-added by httpClient interceptor)
   * @returns Logout response
   */
  logout: async (): Promise<LogoutResponse> => {
    const response = await httpClient.post<LogoutResponse>(AUTH_ENDPOINTS.LOGOUT);
    return response;
  },

  /**
   * Token refresh endpoint
   * Exchanges refresh token for new access token
   * @param refreshToken - Current refresh token
   * @returns New access token
   */
  refreshToken: async (refreshToken: string): Promise<RefreshTokenResponse> => {
    const response = await httpClient.post<RefreshTokenResponse>(AUTH_ENDPOINTS.REFRESH_TOKEN, {
      refreshToken
    });
    return response;
  }
};
